module.exports = __webpack_public_path__ + "static/Staffing2-51f74878f6e221102c91970bcac18533.jpg";